/* global axios */
import ApiClient from './ApiClient';

class SipCredentialsAPI extends ApiClient {
  constructor() {
    super('profile/sip_credential', { apiVersion: 'v2' });
  }

  connection() {
    return axios.get(`${this.url}/connection`);
  }
}

export default new SipCredentialsAPI();
